import { render } from "./ArchivedDocuments.vue?vue&type=template&id=64cfe22c&scoped=true&ts=true"
import script from "./ArchivedDocuments.vue?vue&type=script&lang=ts"
export * from "./ArchivedDocuments.vue?vue&type=script&lang=ts"

import "./ArchivedDocuments.vue?vue&type=style&index=0&id=64cfe22c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64cfe22c"]])

export default __exports__